import { useTranslations } from "next-intl";

import { Card } from "@/components/ui/Card";
import { useCharacteristicsConfig } from "@/config/charecteristics.config";

interface ObjectDetailCharacteristicsProps
  extends React.HTMLAttributes<HTMLDivElement> {
  data: any;
}

export const ObjectDetailCharacteristics = ({
  data,
  className,
}: ObjectDetailCharacteristicsProps) => {
  const t = useTranslations();
  const values = useCharacteristicsConfig(data);

  if (values.length === 0) return null;

  return (
    <section className={className}>
      <h2 className={"object-detail__section-header mb-12"}>
        {t("Characteristics")}
      </h2>
      <Card className={"p-12"}>
        <ul
          className={
            "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-8"
          }
        >
          {values &&
            values.map((item) => {
              const { Icon, translateValue, value } = item;
              console.log("ITEM", item);
              return (
                <li
                  key={item.name}
                  className={"flex items-center gap-8"}
                >
                  <Icon className="w-[2.8rem] h-[2.8rem] text-gray-1100" />
                  <p className={"flex flex-col gap-3"}>
                    <span className="text-gray-1100 font-medium text-md">
                      {translateValue}:
                    </span>
                    <span className="text-gray-1200 font-bold text-lg">
                      {value}
                    </span>
                  </p>
                </li>
              );
            })}
        </ul>
      </Card>
    </section>
  );
};
